<span style="--gradient-colors: {{gradientColors}}; --bg-size: {{ncSpeed * 300}}%;" 
    class="nc-animate-gradient-text {{ncDirection}}">
    {{ncText}}
</span>